module.exports = __webpack_public_path__ + "static/media/location.03095ab4.svg";